export default "__VITE_ASSET__608ffa26__"